import ReportViewer, {
  accountxReportUrl,
} from '@account-root/account-react/src/containers/DigitalReportModule/ReportViewer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import { useHistory, useLocation } from 'react-router';
import { formatDashDate } from 'helpers/StringNumberFunction/FormatDate';
import React from 'react';

export const FADetailReport = () => {
    const history = useHistory();
    const user = JSON.parse(localStorage.getItem('loggedInUser'));
    const accountID = user.accountID;
    let location = useLocation();
    const editData = location?.state as any;

    const parameters = [
        { name: 'p_accountid', value: accountID },
        { name: 'p_companyid', value: editData?.CompanyID },
        { name: 'p_assettype', value: editData?.AssetType },
        { name: 'p_assetcardno', value: editData?.AssetCardNo }, 
        { name: 'p_costcentreid', value: editData?.CostCentreID },
        { name: 'p_year', value: editData?.Year },
        { name: 'p_monthfrom', value: editData?.MonthFrom },
        { name: 'p_monthto', value: editData?.MonthTo },
        {
          name: 'p_purchasedate',
          value: editData?.PurchaseDate
            ? formatDashDate(new Date(editData?.PurchaseDate).toISOString())
            : '',
        },
        { name: 'p_referenceno', value: editData?.ReferenceNo }, 
    ];

    const generatedurl = (reportName, parameters) => {
        let reporturl = reportName;

        parameters?.map((x, index) => {
            const symbol = index === 0 ? '?' : '&';
            if (x?.value !== undefined)
                reporturl = reporturl + symbol + x?.name + '=' + x?.value;
        });
        return reporturl;
    };

    return (
        <>
            <MainHeader
                onClick={() => history.push(`/digital-reports/fixed-assets`)}
                mainBtn="close"
                smTitle="Fixed Assets"
                title={user?.companyName}
                routeSegments={[
                    {name: 'Main Menu'},
                    {name: 'Submenu'},
                    {name: 'Parameters'},
                    {name: 'Fixed Assets Detail Report', current: true},
                ]}
                rightRouteSegments={[{name: 'Report', current: true}]}
            />
            <ContentWrapper style={{maxHeight: '100%'}}>
                {ReportViewer({
                    url: generatedurl('FADetailReport', parameters),
                    host: accountxReportUrl,
                    excludedExportFormat: [],
                })}
            </ContentWrapper>
        </>
    );
}